import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurServices from "./sections/OurServices";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
import FilmSetGallery from "./sections/FilmSetGallery";
import FilmLocationShowcase from "./sections/FilmLocationShowcase";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurServices />
      <FilmSetGallery />
      <FilmLocationShowcase />
      <Contact />
      <Footer />
    </div>;
}